module.exports = __webpack_public_path__ + "static/media/dot-matrix.dfda8f05.svg";